﻿import React, { useState } from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import { Header } from '../../components';
import BodyPainVisualizer from '../../components/bodydiagrams/BodyPainVisualizer';
import { FaUser } from 'react-icons/fa';

const CreateBodyPainPointChart = () => {
        const { currentMode } = useStateContext();
        const [isSubmitting, setIsSubmitting] = useState(false);
        const [patientId, setPatientId] = useState('');
        const [date, setDate] = useState('');

        const handleSave = async () => {
                if (!patientId) {
                        alert('Please enter a Patient ID');
                        return;
                }
                if (!date) {
                        alert('Please select a date');
                        return;
                }

                try {
                        setIsSubmitting(true);
                        // TODO: Implement save logic
                        console.log('Saving pain point data:', { patientId, date });
                } catch (error) {
                        console.error('Error saving pain point data:', error);
                } finally {
                        setIsSubmitting(false);
                }
        };

        const handleSubmit = async () => {
                if (!patientId) {
                        alert('Please enter a Patient ID');
                        return;
                }
                if (!date) {
                        alert('Please select a date');
                        return;
                }

                try {
                        setIsSubmitting(true);
                        // TODO: Implement submit logic
                        console.log('Submitting pain point data:', { patientId, date });
                } catch (error) {
                        console.error('Error submitting pain point data:', error);
                } finally {
                        setIsSubmitting(false);
                }
        };

        return (
                <div className="p-6">
                        <div className="flex justify-between items-center mb-6">
                                <h1 className="text-2xl font-bold text-base-content flex items-center gap-3">
                                        <FaUser className="text-primary" />
                                        Body Pain Point Chart
                                </h1>
                        </div>

                        {/* Loading State */}
                        {isSubmitting && (
                                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                                        <div className="bg-base-100 p-4 rounded-lg shadow-lg">
                                                <p className="text-base-content">Processing...</p>
                                        </div>
                                </div>
                        )}

                        {/* Patient Info Section */}
                        <div className="bg-base-100 rounded-lg shadow mb-6 p-4">
                                <h2 className="text-lg font-semibold mb-4 text-base-content">Patient Information</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                        <div className="flex flex-col">
                                                <label className="text-sm font-medium text-base-content mb-1">
                                                        Patient ID
                                                </label>
                                                <input
                                                        type="text"
                                                        value={patientId}
                                                        onChange={(e) => setPatientId(e.target.value)}
                                                        className="input input-bordered"
                                                        placeholder="Enter Patient ID"
                                                />
                                        </div>
                                        <div className="flex flex-col">
                                                <label className="text-sm font-medium text-base-content mb-1">
                                                        Date
                                                </label>
                                                <input
                                                        type="date"
                                                        value={date}
                                                        onChange={(e) => setDate(e.target.value)}
                                                        className="input input-bordered"
                                                />
                                        </div>
                                </div>
                        </div>

                        {/* Body Pain Visualizer Component */}
                        <div className="bg-base-100 rounded-lg shadow mb-6">
                                <BodyPainVisualizer />
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-end space-x-4">
                                <button
                                        onClick={handleSave}
                                        disabled={isSubmitting}
                                        className="btn btn-primary"
                                >
                                        Save Progress
                                </button>
                                <button
                                        onClick={handleSubmit}
                                        disabled={isSubmitting}
                                        className="btn btn-success"
                                >
                                        Submit
                                </button>
                        </div>
                </div>
        );
};

export default CreateBodyPainPointChart;